import { AspectRatio, Box, Divider, Grid, HStack, Image, Select, Spacer, Stack, Text, useToast } from '@chakra-ui/react';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import useUserStore from '../../../Hooks/Zustand/Store';
import _axios from '../../../Api/AxiosBarrier';
import InstagramAnalyticsPost from './InstagramAnalyticsPost';


function AnalyticsDataStories() {
  const globalState = useUserStore();

  const [dataPost, setDataPost] = useState([]);
  const mediaTypeRef = useRef('');
  const availableMediaTypesRef = useRef([]);
  const toast = useToast();

  const getDataPost = async () => {
    globalState.setIsLoading(true);
    const data = {
      profileKey: globalState.socialKey,
      query: `/${globalState?.socialActive?.platform}`,
    };
    try {
      const res = await _axios.post('/ayrshare-getAllPosts', data);
      if (res.data.status === 'success') {
        if (res.data.posts.length > 0) {
          let dataFix = [];
          const dataPosting = res.data.posts;
          const platformFilters = {
            instagram: (x) => x.mediaProductType === mediaTypeRef.current,
            tiktok: (x) => x.mediaType === mediaTypeRef.current,
            twitter: (x) => x.mediaProductType === mediaTypeRef.current,
            // linkedin: (x) => x.mediaProductType === mediaTypeRef.current,
            // Tambahkan platform lain dengan aturan filter yang sesuai jika diperlukan
            // misalnya: twitter: (x) => x.someProperty === someValue
          };
          const activePlatform = globalState?.socialActive?.platform.toLowerCase();

          const filterFunction = platformFilters[activePlatform];
          if (filterFunction) {
            dataFix = dataPosting.filter(filterFunction);
          } else {
            dataFix = [...dataPosting];
          }

          const updatedFilterData = await Promise.all(
            dataFix.map(async (iterator) => {
              const res = await _axios.post('ayrshare-getAnalyticsPost', {
                profileKey: globalState?.socialKey,
                id: iterator?.id || iterator?.itemId,
                platforms: [globalState?.socialActive?.platform],
                searchPlatformId: true,
              });
              const obj = res.data;
              const { ...analytics } = obj;
              if (analytics.code !== 186) {
                return { ...iterator, analytics };
              } else {
                return iterator;
              }
            })
          );
          setDataPost(updatedFilterData);
        }
      }
    } catch (error) {
      toast({
        title: 'Deoapp.com',
        description: 'Please select a user first.',
        status: 'error',
        position: 'top-right',
        isClosable: true,
      });
      return;
    } finally {
      globalState.setIsLoading(false);
    }
  };

  const getDataAvailableFilter = () => {
    if (globalState?.socialActive?.platform === 'instagram') {
      availableMediaTypesRef.current = ['STORY'];
    }
  };

  useEffect(() => {
    if (availableMediaTypesRef.current.length > 0) {
      mediaTypeRef.current = availableMediaTypesRef.current[0]; // Mengat
    }

    getDataAvailableFilter();
    getDataPost(); // Panggil getDataPost setelah perubahan platform atau mediaType
  }, [globalState.socialKey, globalState?.socialActive?.platform]);

  return (
    <Stack>
      <HStack>
        <Text
          fontSize={'xl'}
          fontWeight='bold'
          color={'gray.600'}>
          Stories {globalState?.socialActive?.platform} Insight
        </Text>
        <Spacer />
        <Box>
          <Select
            value={mediaTypeRef.current}
            onChange={(e) => {
              mediaTypeRef.current = e?.target.value;
              getDataPost(); // Panggil getDataPost setiap kali mediaType berubah
            }}
            placeholder='Select option'>
            {availableMediaTypesRef.current.map((type) => (
              <option
                key={type}
                value={type}>
                {type}
              </option>
            ))}
          </Select>
        </Box>
      </HStack>

      {dataPost?.length > 0 && (
        <Stack>
          {dataPost.map((x, index) => {
            return (
              <Stack
                key={index}
                borderRadius='lg'
                shadow='md'
                // bgColor={'white'}
                borderTopWidth={5}
                borderColor='blue.500'
                p={5}>
                <Grid
                  templateColumns={{ base: '1fr', md: '4fr 1fr' }}
                  gap={5}>
                  <Stack
                    // bgColor={'white'}
                    p={3}
                    fontSize='sm'>
                    <Stack spacing={5}>
                      {Object.entries(x.analytics).map(([key, value]) => (
                        <Stack key={key}>
                          <Text
                            fontSize={'sm'}
                            fontWeight='bold'
                            textTransform={'capitalize'}>
                            {key}
                          </Text>
                          <Divider />
                          {key === 'instagram' ? (
                            <InstagramAnalyticsPost analyticsData={value.analytics} />
                          ) : (
                            <Stack>
                              {Object.entries(value.analytics).map(([keyX, valueX]) => (
                                <Stack key={valueX}>
                                  <Text>{keyX}</Text>
                                  <Text>{valueX}</Text>
                                </Stack>
                              ))}
                            </Stack>
                          )}
                        </Stack>
                      ))}
                    </Stack>
                  </Stack>
                  {x.mediaType === 'VIDEO' ? (
                    <AspectRatio
                      maxW='auto'
                      ratio={9 / 16}>
                      <iframe
                        title='halo'
                        src={x.mediaUrl}
                        allowFullScreen
                      />
                    </AspectRatio>
                  ) : (
                    <AspectRatio
                      maxW='auto'
                      ratio={1}>
                      <Image src={x.mediaUrl} />
                    </AspectRatio>
                  )}
                </Grid>
                <Divider />
                <Stack>
                  <HStack spacing={2}>
                    <Stack>
                      <Text
                        fontSize={'xs'}
                        color='gray.600'>
                        Share via {globalState?.socialActive?.platform} on {moment(x.created).format('LLLL')}
                      </Text>
                    </Stack>
                  </HStack>
                </Stack>
              </Stack>
            );
          })}
        </Stack>
      )}
    </Stack>
  );
}

export default AnalyticsDataStories;
